// extracted by mini-css-extract-plugin
module.exports = {"btn":"__49NYWqS6","icon":"jL5E8KlM"};